import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import styles from './AppShell.module.css';
import ErrorBoundary from '@components/ui/ErrorBoundary';
import { useLocation } from 'react-router-dom';

function SuspenseFallback() {
  return <div className={styles.fallback}>Loading section…</div>;
}

export default function AppShell() {
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => { document.title = 'Super Admin · 1Ayurved'; }, []);

  // Mobile drawer: close on navigation and on Escape.
  useEffect(() => { setNavOpen(false); }, [location.pathname]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setNavOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className={styles.shell}>
      <a href="#main-content" className={styles.skipLink}>Skip to content</a>
      {navOpen && <div className={styles.scrim} onClick={() => setNavOpen(false)} aria-hidden="true" />}
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className={styles.right}>
        <Header onMenuClick={() => setNavOpen(true)} />
        <main id="main-content" className={styles.main} tabIndex={-1}>
          <div className={styles.content}>
            <ErrorBoundary scope="section" resetKey={location.pathname}>
              <Suspense fallback={<SuspenseFallback />}>
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
}
